import { useAtom } from "jotai";
import React, { useEffect, useState } from "react";
import useSound from "use-sound";

import { BOT_NAME } from "../consts";
import { onlinesAtom } from "../jotai/atoms";
import { useUserInfos } from "../liveblocks/maps";

function Doorbell() {
  /**
   * `useUserInfos` gets a map that contains infos of all players that have
   * previously joined, it does not reveal the number of currently online
   * players. So instead, we should use `useOnlines` to get it. But since
   * we need to check if an online player is a bot and `useOnlines` only
   * contains ids, we still need `useUserInfos`.
   */
  const [userInfos] = useUserInfos();
  const [onlines] = useAtom(onlinesAtom);
  const [playEnter] = useSound("/assets/sounds/enter.mp3", {
    volume: 0.5,
  });
  const [playExit] = useSound("/assets/sounds/exit.mp3", { volume: 0.5 });

  const number_people = userInfos
    ? [...onlines].filter((uid) => {
        const user = userInfos[uid];
        if (user) return user.name !== BOT_NAME;
        else return true;
      }).length
    : 0;

  const [prevNumber, setPrevNumber] = useState(number_people);
  useEffect(() => {
    if (number_people > prevNumber) {
      playEnter();
    } else if (number_people < prevNumber) {
      playExit();
    }
    setPrevNumber(number_people);
  }, [number_people, playEnter, playExit, prevNumber]);

  return <></>;
}

export default React.memo(Doorbell);
